export default __webpack_public_path__ + "static/media/mobile_cross_dev_img.d9838037.svg";